module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_baby-0d5a0ae94d27b98f18d0d65b35407212.png";